export default "__VITE_ASSET___wSk$w2q__"